import React from 'react';
import { MapPin } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../../../components/ui/card';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../../../components/ui/select';

export const DeliveryLocationCard = ({ profile, selectedLocation, setSelectedLocation, selectedLocationData }) => (
  <Card data-testid="delivery-location-card">
    <CardHeader>
      <CardTitle className="text-lg flex items-center gap-2">
        <MapPin className="h-5 w-5 text-amber-500" />
        Delivery Location
      </CardTitle>
    </CardHeader>
    <CardContent>
      {profile?.locations && profile.locations.length > 0 ? (
        <Select value={selectedLocation} onValueChange={setSelectedLocation}>
          <SelectTrigger data-testid="location-select">
            <SelectValue placeholder="Select delivery location" />
          </SelectTrigger>
          <SelectContent>
            {profile.locations.map((loc) => (
              <SelectItem key={loc.id} value={loc.id}>
                {loc.name} - {loc.address}, {loc.city}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      ) : (
        <p className="text-gray-500">No delivery locations configured</p>
      )}

      {selectedLocationData && (
        <div className="mt-4 p-3 bg-gray-50 rounded-lg text-sm">
          <p className="font-medium">{selectedLocationData.name}</p>
          <p className="text-gray-600">{selectedLocationData.address}</p>
          <p className="text-gray-600">
            {selectedLocationData.city}, {selectedLocationData.state} {selectedLocationData.zip_code}
          </p>
          {selectedLocationData.delivery_instructions && (
            <p className="text-gray-500 mt-2">
              <span className="font-medium">Instructions:</span> {selectedLocationData.delivery_instructions}
            </p>
          )}
        </div>
      )}
    </CardContent>
  </Card>
);
